if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.preparation = this.form.querySelector('[data-product-preparation]');
        if (this.preparation) {
          this.preparationGrind = this.preparation.querySelector('[data-preparation-grind]');
          this.preparationGrindError = this.preparation.querySelector('[data-preparation-grind-error]');
          this.preparationGround = this.preparation.querySelector('[data-preparation-ground]');
          this.preparationWholeBean = this.preparation.querySelector('[data-preparation-whole-bean]');
          this.preparationMethods = Array.from(this.preparation.querySelectorAll('[data-preparation-method]'));
          this.preparationBrewing = this.preparation.querySelector('[data-preparation-brewing]');
          this.preparationError = this.preparation.querySelector('[data-preparation-method-error]');
          this.preparationCheckout = this.form.querySelector('.shopify-payment-button');
          this.preparation.addEventListener('change', () => this.syncPreparation());
          this.form.addEventListener('reset', () => queueMicrotask(() => this.syncPreparation()));
          this.syncPreparation();
        }
      }

      syncPreparation() {
        if (!this.preparation) return;

        this.preparationGround.disabled = this.preparationGround.dataset.groundDisabled === 'true';
        if (this.preparationGround.disabled) this.preparationGround.checked = false;
        const isGround = this.preparationGround.checked && !this.preparationGround.disabled;
        const hasGrind = this.preparationWholeBean.checked || isGround;
        if (hasGrind) {
          this.preparationGrindError.hidden = true;
          this.preparationWholeBean.removeAttribute('aria-invalid');
          this.preparationGround.removeAttribute('aria-invalid');
        }
        this.preparationBrewing.hidden = !isGround;
        this.preparationMethods.forEach((method) => {
          method.disabled = !isGround;
          method.required = isGround;
          if (!isGround) method.checked = false;
        });
        const hasMethod = this.preparationMethods.some((method) => method.checked);

        if (!isGround || hasMethod) {
          this.preparationError.hidden = true;
          this.preparationBrewing.removeAttribute('aria-invalid');
          this.preparationMethods.forEach((method) => method.removeAttribute('aria-invalid'));
        }
        if (this.preparationCheckout) {
          this.preparationCheckout.hidden = !hasGrind || (isGround && !hasMethod);
        }
      }

      validatePreparation() {
        this.syncPreparation();
        if (!this.preparation) return true;
        if (!this.preparationWholeBean.checked && !this.preparationGround.checked) {
          this.preparationGrindError.hidden = false;
          this.preparationWholeBean.setAttribute('aria-invalid', 'true');
          this.preparationGround.setAttribute('aria-invalid', 'true');
          this.preparationWholeBean.focus();
          this.preparationGrind.scrollIntoView({ block: 'center' });
          return false;
        }
        if (!this.preparationGround.checked || this.preparationMethods.some((method) => method.checked)) return true;

        this.preparationError.hidden = false;
        this.preparationBrewing.setAttribute('aria-invalid', 'true');
        this.preparationMethods.forEach((method) => method.setAttribute('aria-invalid', 'true'));
        (this.preparationMethods[0] || this.preparationBrewing).focus();
        return false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.validatePreparation()) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
